<template>
  <v-main>
      <v-container class="fill-height" fluid>
        <v-row>
          <v-col
            v-for="(allergy, index) in allergies"
            :key="index"
            cols="12"
            xs="12"
            sm="6"
            md="6"
          >
            <v-card class="mx-auto" max-width="300px">
              <v-card-text>
                <span class="title">{{ displayAllergy(allergy) }}</span>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="markVisible(allergy)" outlined rounded :class="allergy.visibility ? 'green lighten-3' : 'red lighten-4'">
                  <label for v-if="allergy.visibility">
                    <v-icon left>mdi-eye-outline</v-icon>I am public
                  </label>
                  <label for v-else>
                    <v-icon left>mdi-eye-off</v-icon>I am hidden
                  </label>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn outlined small fab color="red" @click="deleteAllergy(allergy.id)">
                  <v-icon left>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "allergyComp",
  data: () => ({
    dialog: false,
    valid: true,
  }),
  created() {
    this.$store.dispatch("allergies/aAll");
  },
  computed: {
    ...mapGetters("allergies", {
      allergies: "gAll"
    })
  },
  watch: {
    dialog(val) {
      console.log(val)
    }
  },
  methods: {
    displayAllergy(allergy) {
      if (allergy.medication ==  null) {
        return allergy.allergies.allergy
      } else {
        return allergy.medication.medication
      }
      
    },
    markVisible(allergy) {
      const aller = {
        visibility: !allergy.visibility
      };
      const id = allergy.id;
      //update at the database
      this.$store.dispatch("allergies/aUpdate", { visibility: aller, id: id });
    },
    deleteAllergy(allergyId) {
      this.$store.dispatch("allergies/aDelete", allergyId);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("user/aAddProfile", this.profile).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    }
  }
};
</script>

<style>
</style>